import { ReactNode } from 'react';

/**
 * Tuile de statistique partagée.
 *
 * Reprise à l'identique de l'idiome de `pages/history/components/HistoryStats`
 * plutôt que d'en inventer un second. HistoryStats n'est volontairement pas
 * refactorisée pour consommer ce composant : ses quatre tuiles sont
 * rétrospectives et servent de page de référence, la faire dépendre d'un
 * nouveau fichier ferait porter un risque de régression hors périmètre.
 */

interface TileProps {
  icon: ReactNode;
  label: string;
  value: string;
  hint?: string;
  /** Jauge 0-100 affichée sous la valeur ; le chiffre reste la source de vérité. */
  meter?: number;
}

const StatTile = ({ icon, label, value, hint, meter }: TileProps) => (
  <div className="flex-1 min-w-[160px] rounded-2xl border border-[#623413]/10 bg-white p-4 shadow-sm">
    <div className="flex items-center gap-2 text-xs uppercase tracking-wide text-gray-500">
      <span className="text-[#623413]/60">{icon}</span>
      {label}
    </div>
    <p className="mt-2 text-2xl font-semibold text-[#623413]">{value}</p>
    {meter !== undefined && (
      <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-neutral-100">
        <div
          className="h-full rounded-full bg-[#623413] transition-all"
          style={{ width: `${Math.min(100, Math.max(0, meter))}%` }}
        />
      </div>
    )}
    {hint && <p className="mt-1 text-xs text-gray-400">{hint}</p>}
  </div>
);

export const SkeletonTile = () => (
  <div className="flex-1 min-w-[160px] rounded-2xl border border-[#623413]/10 bg-white p-4 shadow-sm">
    <div className="h-3 w-24 rounded bg-shimmer bg-[length:400%_100%] animate-shimmer" />
    <div className="mt-3 h-6 w-16 rounded bg-shimmer bg-[length:400%_100%] animate-shimmer" />
  </div>
);

export default StatTile;
